import axios from 'axios';
import useAppStore from '../../store/appStore';
import { signOut } from 'firebase/auth';
import { auth } from '../../settings/firebase';
import { Cookies } from 'react-cookie';
import { getAuth } from 'firebase/auth';
import authReady from '../../utils/helpers/authReady';
const cookie = new Cookies();

// Function to handle logout (401)
const handleUnauthorized = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.log('SignOut error (expected if not authenticated):', error.message);
  } finally {
    cookie.remove("jwt");
    useAppStore.getState().clearUser();
    useAppStore.getState().setJwt('');
    window.location.assign('/login');
  }
};

// JWT Decode
const decodeJWT = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
};

const restClient = async ({ url, method = 'get', data = null, headers = {}, params = {}, responseType }) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser ?? (await authReady());
    const jwt = user ? await user.getIdToken() : null;
    const finalHeaders = {
      ...headers,
      ...(jwt && { 'Authorization': `Bearer ${jwt}` })
    };

    if (process.env.REACT_APP_X_AUTH_HEADER === 'true' && jwt) {
      const decodedToken = decodeJWT(jwt);
      
      if (decodedToken) {
        if (decodedToken['X-AUTH-USERID']) {
          finalHeaders['X-AUTH-USERID'] = decodedToken['X-AUTH-USERID'];
        }
        if (decodedToken['X-AUTH-EMAIL']) {
          finalHeaders['X-AUTH-EMAIL'] = decodedToken['X-AUTH-EMAIL'];
        }
      }
    }

    const response = await axios({
      url,
      method,
      data,
      headers: finalHeaders,
      params,
      ...(responseType && { responseType }) 
    });
 
    if (response.data && response.data.data) {
    return response.data.data;
    }
    if (response) {
    return response;
    }
  } catch (error) {
    if (error.response?.status === 401) {
      await handleUnauthorized();
      throw new Error('Unauthorized - redirecting to login');
    }
    
    // Propaga l'errore per React Query
    throw error.response?.data || error.message;
  }
};

export default restClient;
